const calculateBrightness = (width, height, canvasElement) => {
    let ctx = canvasElement.getContext('2d');
    let imageData = ctx.getImageData(0, 0, width, height).data;
    let r, g, b, avg;
    let colorSum = 0;
    let brightness;

    for(let x = 0, len = imageData.length; x < len; x += 4) {
        r = imageData[x];
        g = imageData[x+1];
        b = imageData[x+2];
        avg = Math.floor((r + g + b) / 3);
        colorSum += avg;
    }

    if (colorSum !== 0) {
        brightness = Math.floor(colorSum / (width * height));
    }

    return brightness
};

export default calculateBrightness